// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixData from 'wix-data';
import wixWindow from 'wix-window';

$w.onReady(function () {

	if (wixWindow.multilingual.currentLanguage === "he") {
		$w('#box24').show();
        $w('#box25').show();
	} else {
        $w('#box24').hide();
        $w('#box25').hide();
    }

});

export function coursesDataset_ready() {
	repeaterFormating();
}

export function repeaterFormating () {

	if ($w("#repeater3").data.length <= 0) {
		expandBox($w("#noCoureseBox"));
	} else {
		collapseBox($w("#noCoureseBox"));
		$w('#repeater3').forEachItem( ($item , itemData , index)  => {
			
			//Populate Data
			$item("#titleText").text = itemData.courseName;

			// Format Date
			if (itemData.date !== undefined && itemData.date !== null) {
				$item("#dateText").text = itemData.date.toLocaleDateString('en-GB').substr(0,5);
			} else {
				$item("#dateText").text = "";
			}

			// Format Tags
			getCoursesTags(itemData.courseKey).then( (items) => {
				var tags = items.items[0].tags;
				var formatedTags = "תחום: " + tags[0].tagName;
				for (var i = 1; i < tags.length; i++) {
					formatedTags = formatedTags + ", " + tags[i].tagName;
				}
				$item("#tagsText").text = formatedTags;
    		});

			//Check Description Length
			var description = itemData.shortDescription
			if (description.length > 100) {
				var trimmedDescription = description.substr(0, 97);
				trimmedDescription = trimmedDescription.substr(0, Math.min(trimmedDescription.length, trimmedDescription.lastIndexOf(" ")));
				$item("#descriptionText").text = trimmedDescription + "...";
			} else {
				$item("#descriptionText").text = description
			}
		});
	}
}

function getCoursesTags (courseKey) {
	return wixData.query("CoursesList").eq("courseKey", courseKey).include("tags").find().then( (results) => {
		return results;
    });
}

function getTagByTitle (tagTitle) {
	return wixData.query("CourseTags").eq("title", tagTitle).find().then( (results) => {
		return results.items[0]._id;
    });
}

export function expandBox ($box) {
	if( $box.collapsed ) {
		$box.expand();
	}
	return;
}

export function collapseBox ($box) {
	if( ! $box.collapsed ) {
		$box.collapse();
	}
	return;
}